// extracted by mini-css-extract-plugin
export var menuIcon = "_qb-0";
export var menuIconInline = "_qb-1";